import React from 'react';
import cls from 'classnames';

import { LoaderIndeterminateCircularProps } from './LoaderIndeterminateCircular.types';

const LoaderIndeterminateCircular: React.FC<LoaderIndeterminateCircularProps> = (
	props
) => {
	const { size = 'large', style = 'solid', fill = 'fill3' } = props;

	return (
		<div
			className={cls('loader-indeterminate-circular', size, style, props.className)}
			style={
				{
					'--LoaderIndeterminateCircular-fill': `rgb(var(--${fill}))`,
				} as React.CSSProperties
			}
			aria-label="Loading"
			role="progressbar"
			aria-busy="true"
		>
			<svg
				height="48px"
				width="48px"
				viewBox="0 0 48 48"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<circle cx="24" cy="24" r="21" />
					<circle cx="24" cy="24" r="21" />
					<circle cx="24" cy="24" r="21" />
				</g>
				{props.style === 'gradient' ? (
					<defs>
						<linearGradient id="gradientSmall1" x1="50%" x2="50%" y1="100%" y2="0%">
							<stop offset="0%" stopColor="rgb(var(--onPrimaryContainer))" />
							<stop offset="100%" stopColor="rgb(var(--primaryFixedDim))" />
						</linearGradient>
						<linearGradient id="gradientSmall4" x1="50%" x2="50%" y1="100%" y2="0%">
							<stop offset="0%" stopColor="rgb(var(--success))" />
							<stop offset="100%" stopColor="rgb(var(--accentFixedBright))" />
						</linearGradient>
					</defs>
				) : null}
			</svg>
			{props.text ? <p>{props.text}</p> : null}
		</div>
	);
};

LoaderIndeterminateCircular.displayName = 'LoaderIndeterminateCircular';

export default LoaderIndeterminateCircular;
